var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBattery({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 54.499,
    viewBox: "0 0 65 54.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2271",
    "data-name": "Group 2271",
    transform: "translate(-222 -443.501)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2384",
    "data-name": "Rectangle 2384",
    width: 65,
    height: 44,
    rx: 6,
    transform: "translate(222 454)",
    fill: "#7a8793"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3513",
    "data-name": "Path 3513",
    d: "M32,44h3a3,3,0,0,1,3,3h0a3,3,0,0,1-3,3H32v3a3,3,0,0,1-3,3h0a3,3,0,0,1-3-3V50H23a3,3,0,0,1-3-3h0a3,3,0,0,1,3-3h3V41a3,3,0,0,1,3-3h0a3,3,0,0,1,3,3Z",
    transform: "translate(209 427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3514",
    "data-name": "Path 3514",
    d: "M65,44H77a3,3,0,0,1,3,3h0a3,3,0,0,1-3,3H65a3,3,0,0,1-3-3h0A3,3,0,0,1,65,44Z",
    transform: "translate(202 427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M-17868,5482h-15v-2a7.008,7.008,0,0,1,7-7h1a7.008,7.008,0,0,1,7,7v2Z",
    transform: "translate(18112 -5029.501)",
    fill: "#7a8793"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_4",
    "data-name": "Subtraction 4",
    d: "M-17868,5482h-15v-2a7.008,7.008,0,0,1,7-7h1a7.008,7.008,0,0,1,7,7v2Z",
    transform: "translate(18146 -5029.501)",
    fill: "#7a8793"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/battery.c156e2d6a52cf969d4692d9806eaf13b.svg";
export { ForwardRef as ReactComponent };